import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {DialogActions, DialogContentText} from '@mui/material';
import {Grid, Button, Box} from '@material-ui/core';
// import Tab from '@mui/material/Tab';
// import TabContext from '@mui/lab/TabContext';
// import TabList from '@mui/lab/TabList';
// import TabPanel from '@mui/lab/TabPanel';

// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import FileCopyIcon from '@mui/icons-material/FileCopy';
// import AddCircleIcon from '@mui/icons-material/AddCircle';
// import VisibilityIcon from '@mui/icons-material/Visibility';

import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import 'font-awesome/css/font-awesome.min.css';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {   
  const [open, setOpen] = React.useState(false); 
  const [value, setValue] = React.useState('1');
  const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
  //const [webCourses, setWebCourses] = React.useState([]);
  //const [delId, setDelId] = React.useState(0);

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  // const handleEdit = (index) => {
  //   props.editValidity(index);
  // };

  // const deleteValidityData = (id) => {
  //   setDeleteDialogShow(true);
  //   setDelId(id);
  // };

  const deleteNow = () => {
    //document.getElementById('validityRowId'+delId).style.display='none';
    //props.deleteValidityData(delId);
    setDeleteDialogShow(false);
  };

  function deleteDialogHide(){
		setDeleteDialogShow(false);
	}


  // React.useEffect(() => {
  //   if(props.caseObj){		
  //     setWebCourses(props.studentObj.courses);
  //   }
	// }, [props.caseObj]);

  // const handleChange = (event, newValue) => { //taboneboxid
	// 	// if(newValue==1){
	// 	// //   document.getElementById('taboneboxid').style.display="";
	// 	// //   document.getElementById('tabtwoboxid').style.display="none";
	// 	// //   document.getElementById('tabthreeboxid').style.display="none";
	// 	// }else if(newValue==2){
	// 	// //   document.getElementById('taboneboxid').style.display="none";
	// 	// //   document.getElementById('tabtwoboxid').style.display="";
	// 	// //   document.getElementById('tabthreeboxid').style.display="none";
	// 	// }else if(newValue==3){
	// 	// //   document.getElementById('taboneboxid').style.display="none";
	// 	// //   document.getElementById('tabtwoboxid').style.display="none";
	// 	// //   document.getElementById('tabthreeboxid').style.display="";
	// 	// }else if(newValue==4){
	// 	//   ///window.location.href="testview?testId=st"+testId;
	// 	// }	
	// 	setValue(newValue);
	//   };

  return (props.caseObj?
    <>
      <Dialog style={{margin:5}} maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-45px'}} onClose={handleClose}></DialogTitle>
          <DialogContent style={{height:'88vh'}}>
            <Grid item md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{props.caseObj.contactName}</h3></div>
                  <p>
                  <Box>

                    {/* <div style={{textAlign:'center',marginTop:-12,marginBottom:3}}>
                        <EditIcon style={{marginRight:10,color:'#2c7eea'}} />
												<DeleteIcon style={{marginRight:10,color:'#2c7eea'}} />
												<FileCopyIcon style={{marginRight:10,color:'#2c7eea'}} />
												<AddCircleIcon style={{marginRight:10,color:'#2c7eea'}} />
												<VisibilityIcon style={{marginRight:10,color:'#2c7eea'}} />
                    </div> */}

						<Grid container style={{marginTop:-10}} >
                <Grid item md={6} xs={12} >
                    <Grid container >
                      <Grid item xs={3}>
                        Contact Name
                      </Grid>
                      <Grid item xs={9}>
                        {props.caseObj.contactName}
                      </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} xs={12} >
                    <Grid container >
                      <Grid item xs={3}>
                        Mobile
                      </Grid>
                      <Grid item xs={9}>
                        {props.caseObj.mobile}
                      </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} xs={12} >
                    <Grid container >
                      <Grid item xs={3}>
                        Phone
                      </Grid>
                      <Grid item xs={9}>
                        {props.caseObj.phone}
                      </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} xs={12} >
                    <Grid container >
                      <Grid item xs={3}>
                        Email
                      </Grid>
                      <Grid item xs={9}>
                        {props.caseObj.email}
                      </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} xs={12} >
                    <Grid container >
                      <Grid item xs={3}>
                        Address
                      </Grid>
                      <Grid item xs={9}>
                        {props.caseObj.address}
                      </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} xs={12} >
                    <Grid container >
                      <Grid item xs={3}>
                        City
                      </Grid>
                      <Grid item xs={9}>
                        {props.caseObj.city}
                      </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} xs={12} >
                    <Grid container >
                      <Grid item xs={3}>
                        State
                      </Grid>
                      <Grid item xs={9}>
                        {props.caseObj.state}
                      </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} xs={12} >
                    <Grid container >
                      <Grid item xs={3}>
                        Pin Code
                      </Grid>
                      <Grid item xs={9}>
                        {props.caseObj.zipCode}
                      </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} xs={12} >
                    <Grid container >
                      <Grid item xs={3}>
                        Country
                      </Grid>
                      <Grid item xs={9}>
                        {props.caseObj.country}
                      </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} xs={12} >
                    <Grid container >
                      <Grid item xs={3}>
                       Date Of Birth
                      </Grid>
                      <Grid item xs={9}>
                        {props.caseObj.dateOfBirth}
                      </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} xs={12} >
                    <Grid container >
                      <Grid item xs={3}>
                        Designation
                      </Grid>
                      <Grid item xs={9}>
                        {props.caseObj.designation}
                      </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} xs={12} >
                    <Grid container >
                      <Grid item xs={3}>
                        Department
                      </Grid>
                      <Grid item xs={9}>
                        {props.caseObj.department}
                      </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} xs={12} style={{cursor:'pointer'}} onClick={()=>{window.location='accountdetail?accountNumber='+props.caseObj.accountNumber}} >
                    <Grid container >
                      <Grid item xs={3}>
                      Account Name
                      </Grid>
                      <Grid item xs={9}>
                        {props.caseObj.accountName} {props.caseObj.accountNumber}
                      </Grid>
                    </Grid>
                </Grid>
                {props.caseObj.comment?
                <Grid item md={6} xs={12} >
                    <Grid container >
                      <Grid item xs={3}>
                        Last Comment
                      </Grid>
                      <Grid item xs={9}>
                        {props.caseObj.comment}
                      </Grid>
                    </Grid>
                </Grid>
                :null}
                <Grid item md={6} xs={12} >
                    <Grid container >
                      <Grid item xs={3}>
                        Created By
                      </Grid>
                      <Grid item xs={9}>
                        {props.caseObj.createdAlias} {props.caseObj.createdDateTime}
                      </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} xs={12} >
                    <Grid container >
                      <Grid item xs={3}>
                        Last Modified By
                      </Grid>
                      <Grid item xs={9}>
                        {props.caseObj.lastModifiedAlias} {props.caseObj.lastModifiedDateTime}
                      </Grid>
                    </Grid>
                </Grid>

						</Grid>
					</Box>                      



                  </p>
            </Grid>
          </DialogContent>
      </Dialog>


        <Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete student course.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteNow()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>


    </>:null
  );

});

export default CustomizedDialogs;